module.exports = __webpack_public_path__ + "static/caddy-24401a93609e8a496ca3758030721e85.png";